var setAppointmentModal = function (e){
    if ( e.target.tagName.toLowerCase() == "a" ) return;
    var $cell = $(e.target).closest("td.js-appointment-cal-day");
    var dateValue = $cell.data("date");
    if (!dateValue) return;
    if (isPastDate(dateValue)) return;
    var date_time = $(e.target).find(".js-date-selected").data("date-selected");
    var $input = $("#newAppointmentModal").find("input#appointment-datetimepicker");
    var normalizedValue = normalizeAppointmentValue($input, date_time);
    $input.val(normalizedValue);
    if (window.ModalManager && typeof window.ModalManager.open === 'function') {
      window.ModalManager.open('newAppointmentModal');
    }
}

var searchAppointments = function(){
  var form = $("#js--search-appoinment-form");
  $.ajax({
    type: "get",
    url: form.attr("action") + ".json",
    data: form.serialize(),
    dataType: "json",
    success: function(data) {
      $(".js-appointment-results").html(data.html);
    }
  });
}

var onDateAppointments = function(e){
  var $form = $( e.target ).closest("form");
  var date_params = $form.find("input#appointment-datetimepicker").val();
  var date =  new Date(date_params);

  if (date == "Invalid Date"){
    date = new Date();
  }

  var doctor_id = $form.find("select#appointment_doctor_id").val();

  $.ajax({
    type: "get",
    url: "/appointments/on_date.json?" + "doctor_id=" + doctor_id + "&date=" + date_params,
    dataType: "json",
    success: function(data) {
      $("#js-selected-date").html( date.toString().substring(0, 10) );
      $(".js-on-date-appointments").html( data.html );
    }
  });
}

var renderAppointmentsCal = function(e){
  e.preventDefault();
  var $form = $( e.target ).closest("form");
  $.ajax({
    type: "get",
    url: $form.attr("action") + ".json",
    data: $form.serialize(),
    dataType: "json",
    success: function(data) {
      $(".js-appointments-cal").html(data.html);
    }
  });
}

var render_calendar = function(url){
  var $form = $("#js--search-appoinment-form");
  $.ajax({
    type: "get",
    url: url,
    data: $form.serialize(),
    dataType: "json",
    success: function(data) {
      $(".js-doctor-calendar").html(data.html);
    }
  });
}

var parseDateTime = function(value){
  var date = new Date(value);
  return isNaN(date.getTime()) ? null : date;
}

var isPastDate = function(value){
  var date = parseDateTime(value);
  if (!date) return false;
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date < today;
}

var formatTime = function(date){
  var hours = date.getHours();
  var minutes = date.getMinutes();
  return (hours < 10 ? "0" + hours : hours) + ":" + (minutes < 10 ? "0" + minutes : minutes);
}

var formatDateTime = function(date){
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var paddedMonth = month < 10 ? "0" + month : month;
  var paddedDay = day < 10 ? "0" + day : day;
  return year + "-" + paddedMonth + "-" + paddedDay + " " + formatTime(date);
}

var roundToNextHour = function(date){
  var rounded = new Date(date.getTime());
  rounded.setMinutes(0, 0, 0);
  rounded.setHours(rounded.getHours() + 1);
  return rounded;
}

var roundToNextHourUnlessExact = function(date){
  var rounded = new Date(date.getTime());
  if (rounded.getMinutes() === 0 && rounded.getSeconds() === 0 && rounded.getMilliseconds() === 0) {
    return rounded;
  }
  rounded.setMinutes(0, 0, 0);
  rounded.setHours(rounded.getHours() + 1);
  return rounded;
}

var rescheduleMinTime = function(now){
  var nextHour = roundToNextHour(now);
  nextHour.setHours(nextHour.getHours() + 1);
  return nextHour;
}

var getAppointmentConstraints = function($input, selectedDate){
  var now = new Date();
  var isReschedule = ($input.data("reschedule") === true || $input.data("reschedule") === "true");
  var minDate;
  var minTime = "00:00";

  if (!isReschedule) {
    var leadHours = parseInt($input.data("lead-hours") || 1);
    var minDateTime = new Date(now.getTime() + leadHours * 60 * 60 * 1000);
    minDate = minDateTime;
    if (selectedDate && selectedDate.toDateString() === now.toDateString() && minDateTime.toDateString() === now.toDateString()) {
      minTime = formatTime(minDateTime);
    }
    return { minDate: minDate, minTime: minTime };
  }

  var minTimeDate = rescheduleMinTime(now);
  minDate = minTimeDate.toDateString() !== now.toDateString() ? minTimeDate : now;
  if (selectedDate && selectedDate.toDateString() === now.toDateString() && minTimeDate.toDateString() === now.toDateString()) {
    minTime = formatTime(minTimeDate);
  }

  return { minDate: minDate, minTime: minTime };
}

var normalizeAppointmentValue = function($input, value){
  var selectedDate = parseDateTime(value);
  var constraints = getAppointmentConstraints($input, selectedDate);
  var minDate = constraints.minDate;
  var isReschedule = ($input.data("reschedule") === true || $input.data("reschedule") === "true");
  if (isReschedule) return value;
  var roundedMinDate = roundToNextHourUnlessExact(minDate);
  if (!selectedDate) return formatDateTime(roundedMinDate);
  if (selectedDate < minDate) return formatDateTime(roundedMinDate);
  return value;
}

var setAppointmentError = function($input, message){
  var $container = $input.closest(".form-group");
  var $error = $container.find(".js-appointment-error");
  if (!message) {
    $error.remove();
    $container.removeClass("has-error");
    return;
  }
  if ($error.length === 0) {
    $error = $("<div class=\"text-danger js-appointment-error\"></div>");
    $container.append($error);
  }
  $error.text(message);
  $container.addClass("has-error");
}

var setFormSubmitState = function($form, enabled){
  $form.find("input[type='submit'], button[type='submit']").prop("disabled", !enabled);
}

var validateAppointmentInput = function($input){
  var value = $input.val();
  if (!value) {
    return null;
  }
  var selectedDate = parseDateTime(value);
  if (!selectedDate) {
    return "Invalid date/time";
  }

  var constraints = getAppointmentConstraints($input, selectedDate);
  var minDate = constraints.minDate;
  var minTime = constraints.minTime;
  var now = new Date();
  var isReschedule = ($input.data("reschedule") === true || $input.data("reschedule") === "true");

  if (selectedDate < minDate) {
    return isReschedule ? "Must be today or later." : "Must be at least 1 hour from now.";
  }

  if (selectedDate.toDateString() !== now.toDateString()) {
    return null;
  }

  var minParts = minTime.split(":");
  var minDateTime = new Date(selectedDate.getTime());
  minDateTime.setHours(parseInt(minParts[0]), parseInt(minParts[1]), 0, 0);
  if (selectedDate < minDateTime) {
    return isReschedule ? "Must be at least 1 hour from the next hour." : "Must be at least 1 hour from now.";
  }

  return null;
}

$(document).on("click", ".js-appointment-cal-day", function(e){
  var $appointment_date_field = $("#js--search-appoinment-form #date");
  var date = $(e.target).closest("td.js-appointment-cal-day").data("date");
  if (!date) return;
  if (isPastDate(date)) return;
  if ( $appointment_date_field.length > 0 ) {
    $(".js-appointment-date").html(date);
    $appointment_date_field.val(date);
    searchAppointments();
  }
});

$(document).on("click", ".js-other-appointments", function(e){
  e.preventDefault();
});

$(document).on("click", ".js-calendar-nav", function(e){
  e.preventDefault();
  render_calendar( $(this).attr("href") );
});

$(document).on("change", "input.js-appointment-clinic:checkbox", function(e){
  render_calendar( window.location.href );
  searchAppointments();
});

$( function(){
    // Populate appointment fields when modal opens via ModalManager (utils/modal.js).
    document.addEventListener('modal:opened', function(e) {
      var modalId = e && e.detail && e.detail.modalId;
      var trigger = e && e.detail && e.detail.trigger;
      if (!modalId || !trigger) return;

      var $trigger = $(trigger);
      var appointmentID = $trigger.data('id');
      var patientName = $trigger.data('patient');
      if (appointmentID == null && patientName == null) return;

      var $modal = $('#' + modalId);
      if ($modal.length === 0) return;

      if (patientName != null) $modal.find('.js--patient_name').text(patientName);
      if (appointmentID != null) $modal.find('#appointmentID').val(appointmentID);
    });

    var $appointmentForm = $('form.js-appointment-form');
    if ( $appointmentForm.length > 0 ) {
      $appointmentForm.find("input#appointment-datetimepicker").change( onDateAppointments );
      $appointmentForm.find("select#appointment_doctor_id").change( onDateAppointments );
    }

    var $appointmentDatetimepicker = $(".js-appointment-datetimepicker");
    if ( $appointmentDatetimepicker.length > 0 ) {
      $appointmentDatetimepicker.each(function(){
        var $input = $(this);
        var normalizedValue = normalizeAppointmentValue($input, $input.val());
        if ($input.val() !== normalizedValue) {
          $input.val(normalizedValue);
        }
        $input.datetimepicker({
          format:'Y-m-d H:i',
          onShow: function(){
            var selectedDate = parseDateTime($input.val());
            var constraints = getAppointmentConstraints($input, selectedDate);
            this.setOptions({
              minDate: constraints.minDate,
              minTime: constraints.minTime
            });
          },
          onSelectDate: function(ct){
            var constraints = getAppointmentConstraints($input, ct);
            this.setOptions({
              minDate: constraints.minDate,
              minTime: constraints.minTime
            });
          }
        });
      });
    }

    var $appointmentDoctorSelect = $("select#appointmentDoctorFilter");
    if ( $appointmentDoctorSelect.length > 0 ) {
        $appointmentDoctorSelect.change( renderAppointmentsCal );
    }

    var $filterForm = $("#appointmentsFilter");
    if ($filterForm.length > 0) {
        $filterForm.submit( renderAppointmentsCal );
    }

    var $appointment_date_field = $("#js--search-appoinment-form #date");
    if ( $appointment_date_field.length > 0 ) {
        $appointment_date_field.change( searchAppointments );
    }

    var $calendar = $(".js-appointments-cal");
    if ( $calendar.length > 0 ) {
      $calendar.on("click", "td.js-appointment-cal-day", setAppointmentModal);
    }

});

$(document).on("change", ".js-appointment-datetimepicker", function(){
  var $input = $(this);
  var $form = $input.closest("form");
  var message = validateAppointmentInput($input);
  if (message) {
    setAppointmentError($input, message);
    setFormSubmitState($form, false);
    return;
  }
  setAppointmentError($input, null);
  setFormSubmitState($form, true);
});

$(document).on("submit", "form", function(e){
  var $input = $(this).find(".js-appointment-datetimepicker").first();
  if ($input.length === 0) {
    return;
  }
  var message = validateAppointmentInput($input);
  if (message) {
    e.preventDefault();
    setAppointmentError($input, message);
    setFormSubmitState($(this), false);
  } else {
    setAppointmentError($input, null);
    setFormSubmitState($(this), true);
  }
});

